import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class ListsHelperService {
  sortProperty(property: string, reverseSort: boolean) {
    return function (a: any, b: any) {
      if (!a.hasOwnProperty(property) || !b.hasOwnProperty(property)) {
        return 0;
      }

      let aValue = (typeof a[property] === 'string') ? a[property].toUpperCase() : a[property];
      let bValue = (typeof b[property] === 'string') ? b[property].toUpperCase() : b[property];

      if (aValue > bValue) {
        return reverseSort ? -1 : 1;
      }
      if (bValue > aValue) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortSubPropertyString(property: string, subProperty: any, reverseSort: boolean) {
    return function (a: any, b: any) {
      let aValue: string = '';
      if (a[property] && a[property][subProperty]) {
        aValue = a[property][subProperty];
      }
      let bValue: string = '';
      if (b[property] && b[property][subProperty]) {
        bValue = b[property][subProperty];
      }
      if (aValue.toLowerCase() > bValue.toLowerCase()) {
        return reverseSort ? -1 : 1;
      }
      if (bValue.toLowerCase() > aValue.toLowerCase()) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  // Not converting values to lower case; in case the values are numbers
  sortSubProperty(property: string, subProperty: any, reverseSort: boolean) {
    return function (a: any, b: any) {
      let aValue: string = '';
      if (a[property] && a[property][subProperty]) {
        aValue = a[property][subProperty];
      }
      let bValue: string = '';
      if (b[property] && b[property][subProperty]) {
        bValue = b[property][subProperty];
      }
      if (aValue > bValue) {
        return reverseSort ? -1 : 1;
      }
      if (bValue > aValue) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortMultiSubPropertyString(property: string, subProperty1: any, subProperty2: any, reverseSort: boolean) {
    return function (a: any, b: any) {
      let aValue: string = '';
      if (a[property] && a[property][subProperty1] && a[property][subProperty1][subProperty2]) {
        aValue = a[property][subProperty1][subProperty2];
      }
      let bValue: string = '';
      if (b[property] && b[property][subProperty1] && b[property][subProperty1][subProperty2]) {
        bValue = b[property][subProperty1][subProperty2];
      }
      if (aValue.toLowerCase() > bValue.toLowerCase()) {
        return reverseSort ? -1 : 1;
      }
      if (bValue.toLowerCase() > aValue.toLowerCase()) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortPropertyLength(property: string, reverseSort: boolean) {
    return function (a: any, b: any) {
      if (!a.hasOwnProperty(property) || !b.hasOwnProperty(property)) {
        return 0;
      }

      let aValue: string = a[property];
      let bValue: string = b[property];
      if (aValue.length > bValue.length) {
        return reverseSort ? -1 : 1;
      }
      if (bValue.length > aValue.length) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }

  sortPropertyDate(property: string, reverseSort: boolean) {
    const datePipe = new DatePipe('en-US');
    return function (a: any, b: any) {
      if (!a.hasOwnProperty(property) && !b.hasOwnProperty(property)) {
        return 0;
      }
      if (!a.hasOwnProperty(property) || a[property] == null) {
        return reverseSort ? 1 : -1;
      }
      if (!b.hasOwnProperty(property) || b[property] == null) {
        return reverseSort ? -1 : 1;
      }

      const dateA = datePipe.transform(a[property], 'yyyy-MM-dd');
      const dateB = datePipe.transform(b[property], 'yyyy-MM-dd');

      if (dateA > dateB) {
        return reverseSort ? -1 : 1;
      } else if (dateA < dateB) {
        return reverseSort ? 1 : -1;
      }
      return 0;
    }
  }
}
